import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import ObserverEmitter, { EVENTS } from "../../../emitter/Observer";
import { imgs } from "../../../assets/imgs";
import { useNavigate } from "react-router-dom";
import { ButtonPlay } from "../../../components/common/ButtonPlay";
import { ButtonHome } from "../../../components/common/ButtonHome";
import { PanelActivities } from "../../../components/common/PanelActivities";
import { PanelInstrucionHands } from "../../../components/common/PanelInstrucionHands";
import { DialogBarNew } from "../../../components/common/DialogBarNew";
import { imgInstructionTeam2 } from "../../../assets/imgIntruction/tema2";
import { useGetActivitiesBySubTopic } from "../../../hooks/useGetActivitiesBySubTopic";
import { tasksId } from "../../../types/activityTasks";
import { ModalInfoTextV2 } from "../../../components/common/ModalInfoTextV2";
import { BarStatusActivies } from "../../../components/common/BarStatusActivies";
import { ValidationResultModal } from "../../../components/common/ValidationResultModal";
import { completeOneTask } from "../../../store/slices/menu/tunks";
import { HeaderRedPresentation } from "../../../components/common/HeaderRedPresentation";
import { audiosAssets } from "../../../assets/audio";
import { voicesTypeControl } from "../../../types/audioType";
import { ButtonReturn } from "../../../components/common/ButtonReturn";

const steps = {
	dialogInitial: 1,
	viewActivity: 10,
	dialogTwo: 2,
	panelIntroduction: 3,
	panelTwoVikings: 4,
	panelPastes: 5,
	panelVegetables: 6,
	panelTweezers: 7,
	win: 8,
};

const stepRayCaster = {
	"planeSalchichas": steps.panelTwoVikings,
	Verduras: steps.panelVegetables,
	"planePanes": steps.panelPastes,
	"Pinzas": steps.panelTweezers,
};

export const Team2SubtopicOneActivityOne = () => {
	const navigator = useNavigate();
	const dispatch = useDispatch()
	const [uiToShow, setUiToShow] = useState(steps.dialogInitial);
	const { loaded, activitiesInformation } = useSelector((state) => state.menu);
	const { tasksList, points } = useGetActivitiesBySubTopic(activitiesInformation[tasksId.tema2.activities.subtema1], 1);


	useEffect(() => {
		if (loaded) {
			console.log('tema 2 sub 1 act 1');
			ObserverEmitter.emit(EVENTS.team2.subtopicOne.initScene, 1);
			ObserverEmitter.emit(EVENTS.audiosEvents.pauseActive, true)
			ObserverEmitter.emit(EVENTS.audiosEvents.createAudioScene, audiosAssets.escenarios.onOxxoScene)
		}
	}, [loaded]);

	ObserverEmitter.on(EVENTS.audioInitByTopic, () => {
		ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T2.sub01.sub1_act1_a01T2)
	})

	ObserverEmitter.on(EVENTS.team2.subtopicOne.activityOne.clickedRayCaster, (step) => {
		const clickRayCaster = stepRayCaster[step];
		if (clickRayCaster === undefined) {
			return;
		}

		if (clickRayCaster === steps.panelTwoVikings) {
			setUiToShow(steps.panelTwoVikings);
		}

		if (clickRayCaster === steps.panelPastes) {
			setUiToShow(steps.panelPastes);
		}

		if (clickRayCaster === steps.panelVegetables) {
			setUiToShow(steps.panelVegetables);
		}

		if (clickRayCaster === steps.panelTweezers) {
			setUiToShow(steps.panelTweezers);
		}

	});

	return (
		<>
			<>
				<ButtonPlay />
				<ButtonHome />
				{![1, -1, -2].includes(uiToShow) && (
					<ButtonReturn callback={() => {
						ObserverEmitter.emit(EVENTS.team2.subtopicOne.initScene, 1);
						setUiToShow(1)
					}} />
				)}
			</>
			{uiToShow === -2 && (
				<>
					<BarStatusActivies activities={tasksList} />
				</>
			)}

			{uiToShow === steps.dialogInitial && (
				<>
					<HeaderRedPresentation name="Actividad 1: Operación de Roller" />
					<DialogBarNew
						dialog={"Observa los componentes del Roller y selecciona uno de los ítems señalados para conocer mayor información."}
						percentage={"50%"}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.controlVoices, voicesTypeControl.stop)
							ObserverEmitter.emit(EVENTS.characterAnimations.hiddenModel);
							setUiToShow(steps.viewActivity);
						}}
					></DialogBarNew>
				</>
			)}

			{uiToShow === steps.viewActivity && (
				<>
					<PanelActivities
						buttonText="¡Comenzar!"
						title="Subtema 1: Operación de Roller"
						titleActivity="Actividades por realizar:"
						points={points}
						insigniaBackground={0}
						actionButton={() => {
							setUiToShow(steps.dialogTwo);
						}}
						activities={tasksList}
					/>
				</>
			)}

			{uiToShow === steps.dialogTwo && (
				<>
					<PanelInstrucionHands
						text="Toca encima sobre los objetos para obtener información."
						action={() => {
							setUiToShow(steps.panelIntroduction);
						}}
						img={imgInstructionTeam2.team2_sub1_act_1_01}
					/>
				</>
			)}
			{uiToShow === steps.panelIntroduction && (
				<PanelInstrucionHands
					text="Toca y arrastra con tu dedo para girar la vista."
					action={() => {
						ObserverEmitter.emit(EVENTS.team2.subtopicOne.activityOne.activeEmissiveIntensitySalchichas);
						setUiToShow(-2);
					}}
					img={imgInstructionTeam2.team2_sub1_act_1_02}
				/>
			)}

			{uiToShow === steps.panelTwoVikings && (
				<ModalInfoTextV2
					title="Existen 2 variedades de vikingos: Regular y Grill."
					description={`El número de salchichas que deben estar en el roller lo puedes revisar en la Tabla de Exhibición Variable (ubicada a un costado del roller) y deben cambiarse cada 4 horas en el horario de operación establecido, las salchichas retiradas llévalas al contenedor de mermas en el Cuarto Frío.`}
					url={imgs.exhibicionVikings}
					callback={() => {
						ObserverEmitter.emit(EVENTS.team2.subtopicOne.activityOne.activeEmissiveIntensityClick, "Panes")
						setUiToShow(-1);
					}}
				>
				</ModalInfoTextV2>
			)}
			{uiToShow === steps.panelPastes && (
				<ModalInfoTextV2
					title="Cantidad de panes."
					description={`Verifica que la cantidad de panes sea la misma que el número de salchichas. Es muy importante tener las temperaturas correctas. El agua al interior de la panera debe estar totalmente transparente y sin restos de comida o pan.`}
					url={imgs.pastes}
					callback={() => {
						ObserverEmitter.emit(EVENTS.team2.subtopicOne.activityOne.activeEmissiveIntensityClick, "Verduras")
						setUiToShow(-1);
					}}
				></ModalInfoTextV2>
			)}
			{uiToShow === steps.panelVegetables && (
				<ModalInfoTextV2
					title={"Charolas de verduras y mermas."}
					description={`¡Recuerda!, las charolas de verduras deben estar siempre a la mitad de su capacidad. Al igual que las salchichas, los panes deben ser sustituidos cada 4 horas, lo que retires llévalo al contenedor de mermas en una bolsa. Antes de colocar las nuevas, debes poner hielo en el inserto (contenedor metálico que sostiene las charolas).`}
					url={imgs.verduras}
					callback={() => {
						ObserverEmitter.emit(EVENTS.team2.subtopicOne.activityOne.activeEmissiveIntensityClick, "Pinzas")
						setUiToShow(-1);
					}}
				></ModalInfoTextV2>
			)}
			{uiToShow === steps.panelTweezers && (
				<ModalInfoTextV2
					title={"Pinzas."}
					description={`Es indispensable mantener las pinzas en su lugar, por higiene.`}
					url={imgs.pinzas}
					callback={() => {
						ObserverEmitter.emit(EVENTS.team2.subtopicOne.activityOne.activeEmissiveIntensityClick)
						setUiToShow(steps.win);
					}}
				></ModalInfoTextV2>
			)}
			{uiToShow === steps.win && (
				<ValidationResultModal
					title="¡Bien hecho!"
					dialogModal="Recuerda que la higiene es fundamental en el área de preparación de alimentos."
					buttonTxt="Continuar"
					isCorrect={true}
					action={() => {
						dispatch(
							completeOneTask({
								idActivity: 1,
								pointsWin: 0,
								subtema: tasksId.tema2.activities.subtema1,
							})
						);
						navigator("/home2/tema2/subtema1/activityTwo");
					}}
				/>
			)}
		</>
	);
};
